module.exports = __webpack_public_path__ + "assets/img/5_1274_big.39787896.jpg";